export default function NavHr() {
  return (
    <hr
      className="mt-4 mb-2 w-[50px] border-t border-solid border-gray-400"
      data-component="NavHr"
    />
  );
}
